'use client';

import {useEffect,useRef,useState} from 'react';
import {usePathname} from 'next/navigation';
import {Languages,ChevronDown} from 'lucide-react';

const nav={
  zh:['工具分类','AI 工具排行','AI 使用场景','AI 收费指南','AI 知识百科','关于我们'],
  en:['Tools','AI Rankings','AI Use Cases','AI Pricing','AI Knowledge','About'],
  ja:['ツール分類','AIランキング','AI 活用シーン','AI料金','AI 百科','私たちについて'],
  es:['Categorías','Ranking IA','Casos de uso','Precios IA','Enciclopedia IA','Nosotros']
} as const;
type Lang=keyof typeof nav;
const get=(p:string)=>(nav[p.split('/')[1] as Lang]?p.split('/')[1]:'en') as Lang;
const bare=(p:string)=>p.replace(/^\/(zh|en|ja|es)(?=\/|$)/,'')||'/';
const langs=[{code:'zh' as Lang,label:'简体中文',flag:'🇨🇳'},{code:'en' as Lang,label:'English',flag:'🇺🇸'},{code:'ja' as Lang,label:'日本語',flag:'🇯🇵'},{code:'es' as Lang,label:'Español',flag:'🇪🇸'}];

export default function SiteHeader(){
  const path=usePathname(),[lang,setLang]=useState<Lang>('en');
  const [zhHint,setZhHint]=useState(false);
  const [langOpen,setLangOpen]=useState(false);
  const langRef=useRef<HTMLDivElement>(null);
  useEffect(()=>{
    const onDoc=(e:MouseEvent)=>{if(langRef.current&&!langRef.current.contains(e.target as Node))setLangOpen(false)};
    document.addEventListener('mousedown',onDoc);
    return()=>document.removeEventListener('mousedown',onDoc);
  },[]);
  useEffect(()=>{
    const next=get(path);
    setLang(next);
    document.documentElement.lang=next==='zh'?'zh-CN':next;
    localStorage.setItem('luai_language',next);
    window.dispatchEvent(new CustomEvent('luai-language',{detail:next}));
    const primary=((navigator.languages&&navigator.languages[0])||navigator.language||'').toLowerCase();
    const browserZh=/^zh([-_]|$)/.test(primary);
    const dismissed=localStorage.getItem('luai_zh_hint_dismissed')==='1';
    setZhHint(next==='en'&&browserZh&&!dismissed);
  },[path]);
  const t=nav[lang],prefix=`/${lang}`;
  const change=(v:Lang)=>{
    localStorage.setItem('luai_language',v);
    const code={zh:'zh-CN',en:'en',ja:'ja',es:'es'}[v];
    const alternate=document.querySelector<HTMLLinkElement>(`link[rel="alternate"][hreflang="${code}"]`);
    location.href=alternate?.href||`/${v}${bare(path)}`;
  };
  const dismissZhHint=()=>{localStorage.setItem('luai_zh_hint_dismissed','1');setZhHint(false);};
  return <header>
    <a className="brand" href={`${prefix}/`}><img className="brand-lu-icon" src="/favicon-64.png" alt="Lu" width="30" height="30" decoding="async"/><span>AI</span><em>Tools</em><small className="brand-domain">.com</small></a>
    <nav>
      <a href={`${prefix}/category/all`}>{t[0]}</a>
      <a href={`${prefix}/rankings`}>{t[1]}</a>
      <a href={`${prefix}/scenarios`}>{t[2]}</a>
      <a href={`${prefix}/pricing`}>{t[3]}</a>
      <a href={`${prefix}/knowledge`}>{t[4]}</a>
    </nav>
    <div className="header-actions">
      <div className="lang-select-wrap" ref={langRef}>
        <button type="button" className="lang-switch" aria-label="切换语言" aria-haspopup="listbox" aria-expanded={langOpen} onClick={()=>setLangOpen(v=>!v)}><span className="lang-flag">{langs.find(l=>l.code===lang)?.flag}</span><span>{langs.find(l=>l.code===lang)?.label}</span><ChevronDown size={14}/></button>
        {langOpen&&<div className="lang-menu">{langs.map(l=><button key={l.code} className={l.code===lang?'active':''} onClick={()=>{setLangOpen(false);if(l.code!==lang)change(l.code)}}><span className="lang-flag">{l.flag}</span>{l.label}</button>)}</div>}
        {zhHint&&<div className="lang-hint"><button className="lang-hint-dismiss" aria-label="关闭" onClick={dismissZhHint}>×</button><div className="lang-hint-icon"><Languages size={20}/></div><p className="lang-hint-text">检测到您在使用中文。</p><button className="lang-hint-link" onClick={()=>change('zh')}>切换到简体中文 →</button></div>}
      </div>
      <a className="header-submit-tool" href={`${prefix}/submit`}>{lang==='zh'?'提交工具':lang==='en'?'Submit':lang==='ja'?'登録':'Enviar'}</a>
    </div>
  </header>;
}
